const organization = {
    require_membership: 'El usuario debe ser miembro de la organización para continuar.',
    role_names_not_found: 'Nombres de roles no válidos detectados: {{names,list(type:conjunction)}}. Por favor, crea estos roles primero antes de continuar.',
};
export default Object.freeze(organization);
